module.exports = __webpack_public_path__ + "static/img/yunbottom.1b92a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobel/yunbottom.png
// module id = y19u
// module chunks = 1